module.exports = __webpack_public_path__ + "media/theme/icon__nintendo-6b1b891d.svg";